export default __webpack_public_path__ + "static/media/NathalieGaudinoCelinePeplinski-carre.18381e4f.jpg";